var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-block-editor date-format-item" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between" },
        [
          _c("CustomPicker", {
            attrs: {
              items: _vm.formatTypes,
              idKey: "id",
              labelKey: "label",
              title: "Select Format",
            },
            model: {
              value: _vm.clone.mode,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "mode", $$v)
              },
              expression: "clone.mode",
            },
          }),
          _vm._v(" "),
          _vm.deleteEnabled
            ? _c(
                "SupsisButton",
                {
                  attrs: { danger: "", xxsmall: "" },
                  on: { click: _vm.deleteFormatter },
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("delete")])]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize data-items" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v(_vm._s(_vm.$t("auto.dateFormatItemDateInputS"))),
          ]),
          _vm._v(" "),
          _vm._l(_vm.clone.inputs, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "d-flex gap-5" },
              [
                _c("TiptapEditor", {
                  attrs: {
                    placeholder: "Input Date",
                    "show-attributes": true,
                    "show-emoji": false,
                    "automation-mode": "",
                  },
                  model: {
                    value: _vm.clone.inputs[index],
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.inputs, index, $$v)
                    },
                    expression: "clone.inputs[index]",
                  },
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { disabled: _vm.clone.inputs.length <= 1 },
                    on: {
                      click: function () {
                        return _vm.deleteInput(index)
                      },
                    },
                  },
                  [_vm._v(" sil ")]
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-end w-100" },
        [
          _vm.addInputEnabled()
            ? _c(
                "SupsisButton",
                { attrs: { primary: "" }, on: { click: _vm.addInput } },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("auto.dateFormatItemAddDateInput"))),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.clone.mode === "date.add"
        ? _c("DateAdd", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.sub"
        ? _c("DateSub", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.startOf"
        ? _c("DateStartOf", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.endOf"
        ? _c("DateEndOf", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.isBefore"
        ? _c("DateIsBefore", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.isAfter"
        ? _c("DateIsAfter", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.isBetween"
        ? _c("DateIsBetween", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.isLeapYear"
        ? _c("DateIsLeapYear", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.isWeekend"
        ? _c("DateIsWeekend", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.isTomorrow"
        ? _c("DateIsTomorrow", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.isYesterday"
        ? _c("DateIsYesterday", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.isWeekday"
        ? _c("DateIsWeekday", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "date.isToday"
        ? _c("DateIsToday", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }